import React from 'react'
import { Typography, TextField, Select, Grid } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/system';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentNeutralRoundedIcon from '@mui/icons-material/SentimentNeutralRounded';

const MainContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '18px',
});
const GenerateButton = styled('button')({
    marginTop: '20px',
    backgroundColor: '#2560CD',
    padding: '10px 26px',
    color: 'white',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    fontSize: '14px',
    borderRadius: '10px',
    cursor: 'pointer',
    '&:hover': {
        background: 'black',
        color: 'white',
        transform: 'scale(1.1)',
    },
});

const ExpInput = ({ onSave, onCancel }) => {
    const [jobtype, setJobType] = React.useState('');
    const [company, setCompany] = React.useState('');
    const [jobFunction, setJobFunction] = React.useState('');
    const [experience, setExperience] = React.useState('');
    const [level, setLevel] = React.useState('');
    const [outcome, setOutcome] = React.useState('');
    const [type, setType] = React.useState('');
    const [enjoyment, setEnjoyment] = React.useState('');
    const [allFieldsFilled, setAllFieldsFilled] = React.useState(false);
    const [saveClicked, setSaveClicked] = React.useState(false);

    const handleJobTypeChange = (event) => {
        setJobType(event.target.value);
    };

    const handleJobFunctionChange = (event) => {
        setJobFunction(event.target.value);
    };

    const handleLevelChange = (event) => {
        setLevel(event.target.value);
    };

    const handleCompanyChange = (event) => {
        setCompany(event.target.value);
    };


    const handleOutcomeChange = (event) => {
        setOutcome(event.target.value);
    };

    const handleTypeChange = (event) => {
        setType(event.target.value);
    };

    const handleExperienceChange = (event) => {
        setExperience(event.target.value);
    };

    const handleEnjoymentChange = (value) => {
        setEnjoyment(value);
    };

    React.useEffect(() => {
        const isFilled = jobtype && company && jobFunction && experience && level && outcome && type && enjoyment;
        setAllFieldsFilled(isFilled);
    }, [jobtype, company, jobFunction, experience, level, outcome, type, enjoyment]);

    return (
        <MainContainer>
            <div style={{ display: 'flex', alignItems: 'flex-start', width: '100%', borderBottom: '2px solid #D8D0D0', }}>
                <Typography style={{
                    fontSize: '20px',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 600,
                }}>Add Experience</Typography>
            </div>
            <Grid container spacing={2} style={{ marginTop: 5 }}>
                <Grid item xs={12} sm={6}>
                    <Typography style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                        fontSize: '14px'
                    }}>Company Or Institution <span style={{ color: 'red', marginLeft: '4px' }}>*
                        </span></Typography>
                    <TextField
                        fullWidth
                        value={company}
                        onChange={handleCompanyChange}
                        InputProps={{
                            style: {
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                                borderRadius: '12px'
                            },
                        }}
                        required
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                        fontSize: '14px'
                    }}>Engagement Type <span style={{ color: 'red', marginLeft: '4px' }}>*
                        </span></Typography>
                    <Select
                        value={jobtype}
                        onChange={handleJobTypeChange}
                        fullWidth
                        sx={{ borderRadius: '12px', fontFamily: 'Poppins, sans-serif', fontWeight: 500, fontSize: '14px' }}
                    >
                        <MenuItem value="Full Time" style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Full Time</MenuItem>
                        <MenuItem value="Part Time" style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Part Time</MenuItem>
                        <MenuItem value="Internship" style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Internship</MenuItem>
                        <MenuItem value="Project work" style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Project work</MenuItem>
                        <MenuItem value="Freelance" style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Freelance</MenuItem>
                        <MenuItem value="Pro-bono" style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Pro-bono</MenuItem>
                        <MenuItem value="Course/Certifications" style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Course/Certifications</MenuItem>
                        <MenuItem value="Others" style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Others</MenuItem>
                    </Select>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                        fontSize: '14px'
                    }}>Function <span style={{ color: 'red', marginLeft: '4px' }}>*
                        </span></Typography>
                    <TextField
                        fullWidth
                        required
                        value={jobFunction}
                        onChange={handleJobFunctionChange}
                        InputProps={{
                            style: {
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                                borderRadius: '12px'
                            },
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                        fontSize: '14px'
                    }}>Number of years of experience in this role <span style={{ color: 'red', marginLeft: '4px' }}>*
                        </span></Typography>
                    <Select
                        value={experience}
                        onChange={handleExperienceChange}
                        sx={{ fontFamily: 'Poppins, sans-serif', borderRadius: '12px' }}
                        fullWidth
                    >
                        <MenuItem value={"0-2"} style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>0-2</MenuItem>
                        <MenuItem value={"2-5"} style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>2-5</MenuItem>
                        <MenuItem value={"5-10"} style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>5-10</MenuItem>
                        <MenuItem value={">10"} style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>&gt;10</MenuItem>
                    </Select>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                        fontSize: '14px'
                    }}>Work Type <span style={{ color: 'red', marginLeft: '4px' }}>*
                        </span></Typography>
                    <Select
                        value={type}
                        onChange={handleTypeChange}
                        fullWidth
                        sx={{ borderRadius: '12px', fontFamily: 'Poppins, sans-serif' }}
                    >
                        <MenuItem value="Team" style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Team</MenuItem>
                        <MenuItem value="Individual" style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Individual</MenuItem>
                        <MenuItem value="Both" style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Both</MenuItem>
                    </Select>

                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                        fontSize: '14px'
                    }}>How was your overall performance? <span style={{ color: 'red', marginLeft: '4px' }}>*
                        </span></Typography>
                    <Select
                        value={outcome}
                        onChange={handleOutcomeChange}
                        fullWidth
                        sx={{ borderRadius: '12px', fontFamily: 'Poppins, sans-serif' }}
                    >
                        <MenuItem value={5} style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Well above average</MenuItem>
                        <MenuItem value={4} style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Above average</MenuItem>
                        <MenuItem value={3} style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Average</MenuItem>
                        <MenuItem value={2} style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Below Average</MenuItem>
                        <MenuItem value={1} style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>NA</MenuItem>
                    </Select>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                        fontSize: '14px'
                    }}>Highest Level or Role Performed <span style={{ color: 'red', marginLeft: '4px' }}>*
                        </span></Typography>
                    <Select
                        value={level}
                        onChange={handleLevelChange}
                        fullWidth
                        sx={{ borderRadius: '12px', fontFamily: 'Poppins, sans-serif' }}
                    >
                        <MenuItem value={5} style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Leadership</MenuItem>
                        <MenuItem value={4} style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Senior Level</MenuItem>
                        <MenuItem value={3} style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Mid-Senior Level</MenuItem>
                        <MenuItem value={2} style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Mid-Level</MenuItem>
                        <MenuItem value={1} style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}>Entry Level</MenuItem>
                    </Select>
                </Grid>
            </Grid>
            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <Typography style={{
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 500,
                    fontSize: '14px',
                    marginTop: '15px'
                }}>How would you rate your overall experience? <span style={{ color: 'red', marginLeft: '4px' }}>*
                    </span></Typography>
                <div style={{ border: '1px solid #D8D0D0', padding: '10px', borderRadius: '12px' }}>
                    <IconButton
                        aria-label="Yes"
                        onClick={() => handleEnjoymentChange(1)}
                        color={enjoyment === 1 ? 'primary' : 'default'}
                    >
                        <InsertEmoticonIcon fontSize='large' />
                        <Typography style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '16px'
                        }}>Positive</Typography>
                    </IconButton>
                    <IconButton
                        aria-label="neutral"
                        onClick={() => handleEnjoymentChange(0.5)}
                        color={enjoyment === 0.5 ? 'primary' : 'default'}
                    >
                        <SentimentNeutralRoundedIcon fontSize='large' />
                        <Typography style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '16px'
                        }}>Neutral</Typography>
                    </IconButton>
                    <IconButton
                        aria-label="No"
                        onClick={() => handleEnjoymentChange(0.1)}
                        color={enjoyment === 0.1 ? 'primary' : 'default'}
                    >
                        <SentimentVeryDissatisfiedIcon fontSize='large' />
                        <Typography style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '16px'
                        }}>Negative</Typography>
                    </IconButton>
                </div>
            </div>
            {saveClicked && !allFieldsFilled && (
                <Typography variant="caption" color="error" style={{ marginTop: '10px' }}>
                    Please fill in all required fields.
                </Typography>
            )}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                <GenerateButton onClick={onCancel}>Cancel</GenerateButton>
                <GenerateButton
                    onClick={() => {
                        setSaveClicked(true);
                        if (allFieldsFilled) {
                            onSave({ jobtype, company, level, experience, type, outcome, jobFunction, enjoyment });
                        }
                    }}>Save</GenerateButton>
            </div>
        </MainContainer>
    );
}

export default ExpInput;